class ProjectApi {
    getListByCurrentBusiness() {
        return api.call('get', apiUrl + 'projects/currentBusiness/')
            .then(({ data }) => data);
    }
    get(id) {
        return api.call('get', apiUrl + 'projects/' + id)
            .then(({ data }) => data);
    }
    create(data) {
        return api.call('post', apiUrl + 'projects', data)
            .then(({ data }) => data);
    }
    update(data) {
        return api.call('put', apiUrl + 'projects/' + data.id, data)
            .then(({ data }) => data);
    }
    delete(id) {
        return api.call('delete', apiUrl + 'projects/' + id)
            .then(({ data }) => data);
    }
}

export default ProjectApi;
